import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import FormHelperText from "@mui/material/FormHelperText";
import { useNavigate } from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useAuth } from "../hooks/useAuth";
import { fireDB, auth } from "../config";
import { useForm } from "react-hook-form";
import { Grid } from "@mui/material";
function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Keventers Cafe &amp; Wraps
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function SignIn() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const res = await signInWithEmailAndPassword(
        auth,
        data.email,
        data.password
      );
      const docRef = doc(fireDB, "users", res.user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        login(docSnap.data());
        navigate("/dashboard/orders");
      } else {
        alert("No such document!");
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      alert("An error occurred while fetching user data");
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 8,
        }}
      >
        <Avatar
          sx={{
            m: 1,
            bgcolor: "secondary.main",
            height: 100,
            width: "auto",
            objectfit: "contain",
          }}
          src={"/logo.jpeg"}
          variant="square"
        ></Avatar>
        <Typography component="h1" variant="h5" sx={{ fontWeight: "bold" }}>
          Keventers Café & Wraps
        </Typography>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }}>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                margin="normal"
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                {...register("email", { required: true, email: true })}
              />

              {errors.email && (
                <Typography color="error" sx={{ display: "block" }}>
                  Email is required
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <TextField
                margin="normal"
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                {...register("password", { required: true, minLength: 6 })}
                autoComplete="current-password"
              />
              {errors.password && (
                <Typography color="error" sx={{ display: "block" }}>
                  Password must be at least 6 characters long
                </Typography>
              )}
            </Grid>
          </Grid>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2, backgroundColor: "#E4780E" }}
          >
            Access Dashboard
          </Button>
        </Box>
      </Box>
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Container>
  );
}
